import React from "react";
import { Stack, Box, styled, useTheme, Divider } from "@mui/material";
import MobileMenu from "./mobile-menu";
import { LayoutContainer } from "../container";
import { useAuthStore } from "../../../stores/authStore";
import {
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
  ListItemIcon,
} from "@mui/material";
import Badge from '@mui/material/Badge';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from "@mui/icons-material/Logout";
import { useState } from "react";
import { LanguageSelector } from "../../LanguageSelector";

const StyledLinkTage = styled(Box)(({ theme }) => ({
  padding: "12px 20px",
  fontWeight: 500,
  cursor: "pointer",
  textDecoration: "none",
  border: `1px solid transparent`,
  fontFamily: '"Urbanist"',
  "&.active": {
    borderRadius: "10px",
    background: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
  },
}));

export const headerNav = [
  { title: "Propiedades", href: "/", isAuth: false },

  { title: "Nosotros", href: "/nosotros", isAuth: false },
  {
    title: "Registra tu propiedad",
    href: "/registra-tu-propiedad",
    isAuth: true,
  },
  { title: "Servicios", href: "/servicios", isAuth: false },
  { title: "Transacciónes", href: "/transacciónes", isAuth: true },
];

const AppHeader = () => {
  const theme = useTheme();
  const pathName = window.location.pathname;
  const [anchorEl, setAnchorEl] = useState(null);
  const accessToken = useAuthStore((state) => state.auth.accessToken);
  const open = Boolean(anchorEl);
  const { auth } = useAuthStore();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    auth.reset();
    window.location.href = "/";
  };

  return (
    <header>
      <Box
        bgcolor={theme.palette.background.main}
        sx={{
          position: "fixed",
          width: "100%",
          left: 0,
          right: 0,
          zIndex: 991,
          overflow: "hidden",
        }}
      >
        <LayoutContainer sx={{ overflow: "hidden" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            py={1.5}
          >
            <Box component="a" href="/">
              <Box
                component="img"
                src="/logoNuevo.png"
                width={{ xs: "180px", md: "280px" }}
              />
            </Box>

            <Box sx={{ display: "flex" }}>
              {/*  <Box
                component="ul"
                sx={{ marginTop: "5px", marginBottom: "0px" }}
              >
                <LanguageSelector />
              </Box> */}
              <Box
                component="ul"
                display={{ xs: "none", lg: "flex" }}
                sx={{ listStyle: "none", paddingLeft: "0px" }}
              >
                {headerNav.map((item, index) => {
                  if (item.isAuth && !accessToken) {
                    return null;
                  }
                  return (
                    <Box component="li" key={index}>
                      <StyledLinkTage
                        component="a"
                        href={item.href}
                        className={pathName === item.href ? "active" : ""}
                        color="text.secondary"
                      >
                        {item.title}
                      </StyledLinkTage>
                    </Box>
                  );
                })}
              </Box>
              {!!accessToken ? (
                <Box
                  display={{ xs: "none", lg: "flex" }} 
                  alignItems="center"
                  sx={{ marginTop: "5px" }}
                >
                  <Tooltip title="Cuenta">
                      <IconButton
                          onClick={handleClick}
                          sx={{
                              display: 'flex', 
                              gap: '8px',
                              borderRadius: "10px",
                              bgcolor: open
                                  ? theme.palette.background.main
                                  : undefined,
                              px: "15px",
                              pt: "6px",
                              pb: "12px",
                              fontSize: "16px",
                              fontWeight: 500,
                              fontFamily: "Urbanist",
                              color: "white",
                              zIndex: 999,
                          }}
                      >
                          Cuenta   
                          <Badge
                              color="success"
                              anchorOrigin={{
                                  vertical: 'bottom',
                                  horizontal: 'right',
                              }}
                              variant="dot"
                              sx={{
                                  '& .MuiBadge-dot': {
                                      width: 13,
                                      height: 13,
                                      borderRadius: '50%',
                                      border: '2px solid black',
                                  },
                              }}
                          >
                              <PersonIcon 
                                  sx={{ 
                                      fontSize: 30,
                                      color: '#a95052',
                                  }} 
                              />
                          </Badge>
                      </IconButton>
                  </Tooltip>
                  <Menu
                      disableScrollLock={true}
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      onClick={handleClose}
                      disablePortal
                      anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                      }}
                      transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                      }}
                      PaperProps={{
                          elevation: 4,
                          sx: {
                              mt: 1.5,
                              borderRadius: 2,
                              minWidth: 110,
                              zIndex: 990,
                              maxWidth: "100%",
                              overflow: "hidden",
                          },
                      }}
                      sx={{
                          "& .MuiMenuItem-root": {
                              color: "white",
                              fontSize: "16px",
                              fontFamily: "Urbanist",
                              fontWeight: 500,
                          },
                      }}
                  >
                      <MenuItem
                          component="a"
                          href="/contactanos"
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                          Soporte
                      </MenuItem>
                      <MenuItem onClick={handleLogout}>
                          <ListItemIcon>
                              <LogoutIcon fontSize="small" />
                          </ListItemIcon>
                          Cerrar sesión
                      </MenuItem>
                  </Menu>
              </Box>
              ) : (
                <Box
                  component="ul"
                  display={{ xs: "none", lg: "flex" }}
                  sx={{ listStyle: "none", paddingLeft: "0px" }}
                >
                  <Box component="li">
                    <StyledLinkTage
                      component="a"
                      href={"/sign-in"}
                      color="text.secondary"
                    >
                      Iniciar sesión
                    </StyledLinkTage>
                  </Box>
                  <Box component="li">
                    <StyledLinkTage
                      component="a"
                      href={"/sign-up"}
                      color="text.secondary"
                    >
                      Registrarse
                    </StyledLinkTage>
                  </Box>
                </Box>
              )}
            </Box>
            <Box display={{ xs: "block", lg: "none" }}>
              <MobileMenu />
            </Box>
          </Stack>
        </LayoutContainer>
        <Divider variant="fullWidth" orientation="horizontal" />
      </Box>
    </header>
  );
};

export default AppHeader;
